import { Component, inject } from '@angular/core';
import { EduIconButtonComponent } from '@atoms/icon-button/icon-button.component';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { SharedCommonModule } from '../../common.module';
import { SeverityLevel } from '../../types';
import { EduIconComponent, Icons } from '@atoms/icon/icon.component';
import { toastStyles } from './toast.variants';

@Component({
  selector: 'edu-toast',
  templateUrl: './toast.component.html',
  imports: [
    ToastModule,
    EduIconComponent,
    ButtonModule,
    EduIconButtonComponent,
    SharedCommonModule,
  ],
})
export class ToastComponent {
  Icons = Icons;
  messageService = inject(MessageService);

  toastDesignTokens = {
    colorScheme: {
      dark: {
        root: {
          width: 'var(--container-lg)',
          borderRadius: 'var(--radius-lg)',
          borderWidth: '0',
        },
        info: {
          shadow: 'var(--color-line)',
        },
        success: {
          shadow: 'var(--color-line)',
        },
        warn: {
          shadow: 'var(--color-line)',
        },
        error: {
          shadow: 'var(--color-line)',
        },
      },
    },
  };

  styles(severity: string) {
    return toastStyles({
      severity: severity as SeverityLevel,
    });
  }
}
